// Modal responsável por cadastrar um novo fórum.

import React from 'react';

const NovoForumModal = () => {
  return (
    <div
      className="modal fade"
      id="forumModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Cadastrar Novo Fórum
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form method="post" action="/api/new/forum">
            <div className="modal-body">
              <label htmlFor="m-cadastrar-descricaoLbl">Descrição</label>
              <input
                type="text"
                id="m-cadastrar-descricao"
                className="form-control"
                name="descricao"
              />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">
                Fechar
              </button>
              <button type="submit" className="btn btn-primary">
                Salvar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NovoForumModal;